export default "__VITE_ASSET__d1d69231__"